import CustomFieldsController from "core-app/../stimulus/controllers/dynamic/admin/custom-fields.controller";

export function apply() {
  let controllerPrototype = CustomFieldsController.prototype as any;
  let originalAddOption = controllerPrototype.addOption;
  controllerPrototype.addOption = function () {
    originalAddOption.call(this);

    const count = this.customOptionRowTargets.length - 1;
    const last = this.customOptionRowTargets[count];
    const symbolField = last.querySelector('.custom-option-symbol input') as HTMLInputElement;
    symbolField.setAttribute('name', `custom_field[custom_options_attributes][${count}][symbol]`);
    symbolField.setAttribute('id', `custom_field_custom_options_attributes_${count}_symbol`);
  }
}
